// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");

function WarningSection__Jsx3(props) {
  return JsxRuntime.jsx("section", {
              children: props.children,
              className: "font-medium text-base leading-tight border border-tan-chino bg-tan-citrine text-tan-warning-text text-center p-5"
            });
}

var make = WarningSection__Jsx3;

exports.make = make;
/* react/jsx-runtime Not a pure module */
